import { message } from 'antd';
import i18n from '../i18n';
import { patchWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const handlePublishMyday = async (mydayId: number, onOk?: () => void) => {
  try {
    const response = await patchWithCSRF(`${envApiUrl}/mydays/${mydayId}/publish`, {});
    console.log('Published Myday: response: ', response);
    message.success(i18n.t('myday.mydayPublished'));
    onOk?.();
    return response.data;
  } catch (err: any) {
    console.error('handlePublishMyday error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || i18n.t('myday.mydayPublishFailed'));
  }
};
